var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 6.66683C13.3332 9.9955 9.6405 13.4622 8.4005 14.5328C8.28499 14.6197 8.14437 14.6667 7.99984 14.6667C7.85531 14.6667 7.71469 14.6197 7.59917 14.5328C6.35917 13.4622 2.6665 9.9955 2.6665 6.66683C2.6665 5.25234 3.22841 3.89579 4.2286 2.89559C5.2288 1.8954 6.58535 1.3335 7.99984 1.3335C9.41433 1.3335 10.7709 1.8954 11.7711 2.89559C12.7713 3.89579 13.3332 5.25234 13.3332 6.66683Z",
    stroke: "#18466F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.6665C9.10457 8.6665 10 7.77107 10 6.6665C10 5.56193 9.10457 4.6665 8 4.6665C6.89543 4.6665 6 5.56193 6 6.6665C6 7.77107 6.89543 8.6665 8 8.6665Z",
    stroke: "#18466F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon2);
export default __webpack_public_path__ + "static/media/locationicon2.dcd7d2e2b223c5aef5eb760cb194fe51.svg";
export { ForwardRef as ReactComponent };